<div class="content">
  <img class="logo" width="300" src="./assets/images/jeans-logo.png" />
  <div class='flexed'>
    @if (!authed()) {
      <button mat-fab color="primary" routerLink="/login">Login</button>
      <button mat-fab color="accent" routerLink="/register">Join</button>
    }
    @if (authed()) {
      <button mat-fab color="warn" (click)="logout()">Logout</button>
    }
  </div>
</div>
